//AccountInfoModel.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelectedStudent } from "features/StudentData/studentSlice"; // Adjust path
const InfoRow = ({ label, value }) => (
  <Grid container spacing={1} sx={{ mb: 1 }}>
    <Grid item xs={4}>
      <MDTypography variant="button" fontWeight="medium" color="text">
        {label}:
      </MDTypography>
    </Grid>
    <Grid item xs={8}>
      <MDTypography variant="button" color="text">
        {value || "-"}
      </MDTypography>
    </Grid>
  </Grid>
);

export default function AccountInfoModal({ open, onClose, account }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const navigate = useNavigate();
  const dispatch = useDispatch();


  if (!account) return null;



  const handleEdit = () => {

    const mappedStudent = {
      account: {
        accountId: account.id,
        firstName: account.name.split(" ")[0],
        lastName: account.name.split(" ").slice(1).join(" ") || "",
        address: account.address,
        role: account.role, // or derive from role
        extra: {
          standard: account.className,
          rollNumber: account.rollNumber,
          // guardians: [account.primaryGuardian, account.secondaryGuardian].filter(Boolean),
          guardians: account.guardians && account.guardians.length > 0
            ? account.guardians
            : [account.primaryGuardian, account.secondaryGuardian].filter(Boolean),
          rfidTag: "", // not in modal, can be fetched later
        },
      },
    };

    dispatch(setSelectedStudent(mappedStudent)); // Set in Redux
    onClose();
    navigate("/Create/Account-details");
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: darkMode
            ? "rgba(40, 40, 40, 0.85)"
            : "rgba(255, 255, 255, 0.85)",
          backdropFilter: "blur(6px)",
          borderRadius: 3,
          color: darkMode ? "#fff" : "#000",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0,0,0,0.3)",
        },
      }}
    >
      <DialogTitle>Account Information</DialogTitle>
      <DialogContent dividers>
        <InfoRow label="Name" value={account.name} />
        <InfoRow label="Class" value={account.className} />
        <InfoRow label="Address" value={account.address} />
        <InfoRow label="Primary Guardian" value={account.primaryGuardian} />
        <InfoRow label="Secondary Guardian" value={account.secondaryGuardian} />
        {/* {account.journeys?.length > 0 && (
          <InfoRow
            label="All Journeys"
            value={account.journeys.map((j) => j).join(", ")}
          />
        )} */}
        <div style={{ display: "flex", marginTop: "10px" }}>

          {/* Label */}
          <div
            style={{
              minWidth: "140px",
              fontSize: "13px",
              color: "#6b778c",
              fontWeight: 600,
              paddingTop: "10px",
            }}
          >
            All Journeys:
          </div>

          {/* Box with multiple rows */}
          <div
            style={{
              flex: 1,
              border: "1px solid #dfe3e8",
              borderRadius: "6px",
              overflow: "hidden",
              background: "#f7f9fb",
              marginLeft: '10px'
            }}
          >
            {account.journeys.map((j, index) => (
              <div
                key={index}
                style={{
                  padding: "10px 12px",
                  fontSize: "13px",
                  color: "#5e6c84",
                  borderBottom:
                    index !== account.journeys.length - 1
                      ? "1px solid #e6e6e6"
                      : "none",
                }}
              >
                {j}
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <MDButton
          onClick={onClose}
          variant="outlined"
          color={darkMode ? "light" : "dark"}
        >
          OK
        </MDButton>
        <MDButton onClick={handleEdit} variant="contained" color="info">
          Edit
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}